import leadersAPI from 'media-base-ui/utils/leadersAPI';

import actionCreators from './actionCreators';

const LIMIT = 5;

const fetchPlayerTotalsData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestPlayers());

    try {
        const data = await leadersAPI.fetchPlayerTotalsData({
            season,
            gameType
        });

        const pointsLeaders = leadersAPI.getLeaders(data.data, [
            // sort order
            {property: 'points'},
            {property: 'gamesPlayed', direction: 'ASC'},
            {property: 'player.id', direction: 'DESC'}
        ], LIMIT);

        const goalsLeaders = leadersAPI.getLeaders(data.data, [
            // sort order
            {property: 'goals'},
            {property: 'points'},
            {property: 'gamesPlayed', direction: 'ASC'},
            {property: 'player.id', direction: 'DESC'}
        ], LIMIT);

        dispatch(actionCreators.getPointsLeaders(pointsLeaders, gameType));
        dispatch(actionCreators.getGoalsLeaders(goalsLeaders, gameType));

        dispatch(actionCreators.playersResponse(true, data.data, gameType, []));
    } catch (error) {
        dispatch(actionCreators.playersResponse(false, [], null, error))
    }
};

const fetchGoalieTotalsData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestGoalies());

    try {
        const data = await leadersAPI.fetchGoalieTotalsData({
            season,
            gameType
        });

        const winsLeaders = leadersAPI.getLeaders(data.data, [
            // sort order
            {property: 'wins'},
            {property: 'savePercentage'},
            {property: 'player.id', direction: 'DESC'}
        ], LIMIT);
        const gaaLeaders = leadersAPI.getGAALeaders(data.data, LIMIT, gameType);

        dispatch(actionCreators.getWinsLeaders(winsLeaders, gameType));
        dispatch(actionCreators.getGAALeaders(gaaLeaders, gameType));

        dispatch(actionCreators.goaliesResponse(true, data.data, gameType, []));
    } catch (error) {
        dispatch(actionCreators.goaliesResponse(false, [], null, error))
    }
};

const setSelectedGameType = (gameType) => dispatch => {
    dispatch(actionCreators.setSelectedGameType(gameType))
};


export default {
    fetchPlayerTotalsData,
    fetchGoalieTotalsData,
    setSelectedGameType
};